export const NAME = 'harvesterManager';
